import { signOut } from "@kaplan-labs/up-auth-api-client";
import { EnvelopeIcon, StudentIcon, UserIcon } from "@phosphor-icons/react";
import { ListDashesIcon } from "@phosphor-icons/react/dist/ssr/ListDashes";
import { ReceiptIcon } from "@phosphor-icons/react/dist/ssr/Receipt";
import { SignOutIcon } from "@phosphor-icons/react/dist/ssr/SignOut";
import { usePathname } from "next/navigation";

import { ProfileType, useProfile } from "@up/data";
import { UPLink } from "@up/ui";

export function ProfileNav() {
  const pathname = usePathname();
  const profile = useProfile();

  return (
    <ul className="flex flex-wrap items-center justify-center md:flex-col md:items-start md:py-5 md:bg-[#F6F6F6]">
      <li>
        <UPLink
          href="/profile"
          className={`flex px-5 py-1 text-lg flex-col items-center !text-black md:flex-row md:gap-2 md:py-2 ${
            pathname === "/profile" ? "font-bold" : "underline"
          }`}
        >
          <UserIcon size={24} />
          Profile
        </UPLink>
      </li>
      <li>
        <UPLink
          href="/profile/communication-settings"
          className={`flex px-5 py-1 text-lg flex-col items-center !text-black md:flex-row md:gap-2 md:py-2 ${
            pathname === "/profile/communication-settings"
              ? "font-bold"
              : "underline"
          }`}
        >
          <EnvelopeIcon size={24} />
          Communication Settings
        </UPLink>
      </li>
      {profile.data?.type === ProfileType.Guardian ? (
        <li>
          <UPLink
            href="/profile/students"
            className={`flex px-5 py-1 text-lg flex-col items-center !text-black md:flex-row md:gap-2 md:py-2 ${
              pathname === "/profile/students"
                ? "font-bold"
                : "underline"
            }`}
          >
            <StudentIcon size={24} />
            My Students
          </UPLink>
        </li>
      ) : null}
      <li>
        <UPLink
          href="/profile/orders"
          className={`flex px-5 py-1 text-lg flex-col items-center !text-black md:flex-row md:gap-2 md:py-2 ${
            pathname === "/profile/orders" ? "font-bold" : "underline"
          }`}
        >
          <ReceiptIcon size={24} />
          Orders
        </UPLink>
      </li>
      {profile.data?.type === ProfileType.Student ? (
        <li>
          <UPLink
            href="/profile/courses"
            className={`flex px-5 py-1 text-lg flex-col items-center !text-black md:flex-row md:gap-2 md:py-2 ${
              pathname === "/profile/courses" ? "font-bold" : "underline"
            }`}
          >
            <ListDashesIcon size={24} />
            Courses
          </UPLink>
        </li>
      ) : null}
      <li className="md:pt-4">
        <button
          className="flex px-5 py-1 text-lg flex-col items-center text-black underline opacity-60 md:flex-row md:gap-2 md:py-2"
          onClick={signOut}
        >
          <SignOutIcon size={24} />
          Sign Out
        </button>
      </li>
    </ul>
  );
}
